import { createFileRoute } from "@tanstack/react-router";
import MarketplaceInsuranceHub from "@/pages/MarketplaceInsuranceHub";
export const Route = createFileRoute("/marketplace-insurance-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Marketplace Insurance & TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Marketplace insurance plans for TMS, SAINT TMS, and SPRAVATO. Learn about ACA marketplace coverage and benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Marketplace Insurance & TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Marketplace insurance plans for TMS, SAINT TMS, and SPRAVATO. Learn about ACA marketplace coverage and benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/marketplace-insurance-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/marketplace-insurance-tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MarketplaceInsuranceHub />;
}
